import { useEffect, useRef } from 'react';
// Custom hook to get previous values
   export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}